<template>
  <!-- 电商小包 -->
  <div class="packet">
    <div class="wrap_s" style="width: 100%; margin: 16px 0; height: 50px">
      <el-row :gutter="10">
        <!-- <el-col :span="5">
          <div
            class="all-info transportWrap"
            style="width: 100%; height: 50px; float: left"
          >
            <el-select v-model="transportQuery" placeholder="请选择">
              <el-option
                v-for="(item, index) of allLine"
                :key="index"
                :label="item.nameCn"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <span
              style="
                z-inde: -1;
                position: absolute;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #999;
                left: 22px;
                top: 14px;
              "
              >运输方式<el-divider
                style="margin: 0 16px"
                direction="vertical"
              ></el-divider
            ></span>
          </div>
        </el-col> -->
        <el-col :span="22">
          <div
            style="
              width: 100%;
              padding: 0 1px;
              box-sizing: border-box;
              float: left;
              border-radius: 10px;
              position: relative;
            "
          >
            <el-row :gutter="0">
              <el-col :span="12">
                <div
                  @click.stop="
                    (show1 = !show1),
                      (show2 = false),
                      (show3 = false),
                      (activeprovince = 'province')
                  "
                  class="selectWrap1"
                  style="
                    height: 50px;
                    display: flex;
                    align-items: center;
                    padding: 0 0 0 20px;
                    box-sizing: border-box;
                    background: #f5f5f5;
                    border-radius: 100px;
                    margin-left: 10px;
                    cursor: pointer;
                  "
                >
                  <span
                    style="
                      font-size: 16px;
                      font-family: PingFang SC;
                      font-weight: 500;
                      color: #999;
                      width: 72px;
                    "
                    >起运地</span
                  >
                  <el-divider
                    style="margin: 0 16px"
                    direction="vertical"
                  ></el-divider>
                  <div class="LR_center" style="width: 100%">
                    <div
                      style="font-size: 16px; font-weight: bold; color: #333333"
                    >
                      {{ fromstoreName }}
                    </div>
                    <div class="divider">
                      <i
                        class="el-icon-arrow-down"
                        style="margin-right: 20px"
                      ></i>
                    </div>
                  </div>
                </div>
                <p
                  v-show="showFormCity"
                  style="position: absolute; left: 80px; color: #FF4D01"
                >
                  请输入起运城市
                </p>
                <!-- <div class="transition_son" @click.stop> -->
                  <!-- new -->
                              <transition name="el-zoom-in-top">
                                <div
                                  class="transition_son"
                                  style="z-index: 2"
                                  @click.stop
                                  v-show="show1"
                                >
                                  <transition name="el-zoom-in-top">
                                    <div
                                      class="transition-box"
                                      style="min-width: 539px"
                                    >
                                      <div>
                                        <div class="one-1">
                                          <div class="left" ref="left1">
                                            <ul class="left-all">
                                              <li
                                                style="font-size: 16px"
                                                class="left-tips"
                                                v-for="(
                                                  item, index
                                                ) of startPlaceList"
                                                :key="index"
                                                @click.stop="
                                                  selectItem1(
                                                    index,
                                                    $event,
                                                    item
                                                  )
                                                "
                                                ref="lettersList"
                                                :class="{
                                                  current: showTag1 == index,
                                                }"
                                              >
                                                {{ item.code }}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div style="height: 20px"></div>
                                        <div class="right" ref="right1">
                                          <ul class="right-all">
                                            <li
                                              style="font-size: 16px"
                                              class="shops-li right-item-hook1"
                                              v-for="(
                                                item, index
                                              ) of startCitylist"
                                              :key="index"
                                            >
                                              <div class="two-left">
                                                {{ item.letters }}
                                              </div>
                                              <div class="two-right">
                                                <div
                                                  class="two-all"
                                                  v-for="(
                                                    _item, _index
                                                  ) of item.content"
                                                  :key="_index"
                                                  :class="{
                                                    twoShow:
                                                      fromstoreName ==
                                                      _item.namec,
                                                  }"
                                                  @click="Qdcity(_item)"
                                                >
                                                  {{ _item.namec }}
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </transition>
                                </div>
                              </transition>
                <!-- </div> -->
              </el-col>
              <el-col :span="12">
                <div class="selectWrap2">
                  <div
                    @click.stop="
                      (show2 = !show2),
                        (show1 = false),
                        (show3 = false),
                        (activecountry = 'endCountry')
                    "
                    style="
                      height: 50px;
                      display: flex;
                      align-items: center;
                      padding: 0 0 0 20px;
                      box-sizing: border-box;
                      background: #f5f5f5;
                      border-radius: 100px;
                      margin-left: 10px;
                      cursor: pointer;
                    "
                  >
                    <span
                      style="
                        font-size: 16px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #999;
                        width: 80px;
                      "
                      >目的国</span
                    >
                    <el-divider
                      style="margin: 0 16px"
                      direction="vertical"
                    ></el-divider>
                    <div class="LR_center" style="width: 100%">
                      <div
                        style="
                          font-size: 16px;
                          font-weight: bold;
                          color: #333333;
                        "
                      >
                        {{ tocountryName }}
                      </div>
                      <div class="divider">
                        <i
                          class="el-icon-arrow-down"
                          style="margin-right: 20px"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <p
                    v-show="showActivecountry"
                    style="position: absolute; left: 84px; color: #FF4D01"
                  >
                    请输入目的地
                  </p>
                  <div class="transition_son" @click.stop>
                    <el-collapse-transition name="el-zoom-in-top">
                      <div
                        v-show="show2"
                        class="transition-box"
                        style="min-width: 539px"
                      >
                        <el-tabs
                          v-model="activecountry"
                          @tab-click="handleClickTips"
                        >
                          <el-tab-pane
                            class="namedome"
                            label="国家"
                            name="endCountry"
                          >
                            <div
                              style="float: left"
                              v-for="(item, index) of endList"
                              :key="index"
                            >
                              <span
                                class="searchBtn"
                                @click.stop="handleEnd(item)"
                                >{{ item.countryName }}</span
                              >
                            </div>
                          </el-tab-pane>
                        </el-tabs>
                      </div>
                    </el-collapse-transition>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="2">
          <div style="float: left; width: 98px" class="step5">
            <el-button
              style="
                width: 100%;
                border-radius: 25px;
                float: left;
                height: 50px;
                font-size: 24px;
                font-weight: bold;
                color:#fff;
              "
              @click="handleSearch()"
              type="primary"
              >查询</el-button
            >
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";
import FBAicon1 from "../../assets/images/FBAicon1.png";
import FBAicon2 from "../../assets/images/FBAicon2.png";
import { setArrayChildrenLevel } from "../../assets/js/utils";

export default {
  mixins: [],
  components: {},
  data() {
    return {
      startPlaceList: [],
      startCitylist: [],
      showTag1: 0,
      fromstoreName: "",

      startList: [], // 起运地
      endList: [], // 目的地
      startFisrtList: [], // 起运地一级目录
      startSecondList: [], // 起运地二级目录
      info: [], // 起运地城市
      firstvalue: null, // 起运地一级数据
      secondValue: null, // 起运地二级数据
      endValue: null, // 目的国数据
      allLine: [], // 运输路线
      infoValue: null, //

      HeaderCount: {},
      typeInfo: 1, // 1-首页  2-进入页
      showTag: 0,
      showTag1: 0,
      showCurrent: null,
      showIndex: -1,
      typeTips: 1, //
      payType: false,
      BillItem: {},
      isShow: false,
      editableTabs: [{ name: "", label: "国家", name: "country", list: [] }],
      listHeight: [],
      scrollY: 0, //实时获取当前y轴的高度
      clickEvent: false,
      rightList: [],
      letters: [],
      listHeight1: [],
      scrollY1: 0, //实时获取当前y轴的高度
      clickEvent1: false,
      rightList1: [],
      letters1: [],
      isIndeterminate: false,
      checkAll: false,
      warehouseStroe: [],
      activeprovince: "province",
      activeStar: "",
      activecountry: "country",
      show1: false,
      show2: false,
      show3: false,
      loadingStoreList: false,
      gridData: false,
      isQueryLowestPrice: false,
      setColor: -1,
      countryData: {},
      searchType: false,
      itemWrap: {},
      countData: {},
      theadData: [],
      tableData: [],
      NodisType: true,
      hotcityLIst: [],
      hotStyleLIst: [],
      ProgType: false,
      transportCodes: [],
      transportQuery: "",
      goodstypeId: 0,
      transportTypeQueryList: [],
      TransportationcheckLisy: [],
      goodsTypeQueryList: [],
      activities: [],
      props: {
        value: "namec",
        label: "namec",
      },
      checked1: false,
      checked2: false,
      whereIDlist: [],
      whereCountryid: "", //国家id
      whereStoreid: "", //仓库id
      Typelist: [
        { name: "FBA", url1: FBAicon1, url2: FBAicon2, index: 3 },
        { name: "电商小包", url1: FBAicon1, url2: FBAicon2, index: 4 },
      ],
      thatALLcklist: [],
      thatFBAcklist: [],
      FBAfromCk: [], // FBA 起运地数据
      FBAtoCk: [], //  FBA 目的地
      Sonindex: 1,
      activeIndex: null,
      topType: false,
      lableData: [],
      lableCountry: [],
      WarehouseList: [],
      activeType: 0,
      weight: "",
      PricesHeader: [],
      PricesCount: [],
      provinceList: [],
      tostoreName: "",
      tocountryName: "",
      fromProvinceid: "", //起运省id
      fromCityid: "", //起运城市id
      toCountryid: "", //目的地国家id
      toStoreid: "", //目的仓库id
      counryChildren: [],
      showTive: false,
      showWarehouseStroe: false,
      showActivecountry: false,
      showFormCity: false,
    };
  },
  watch: {
    topType: function (val, oldval) {
      if (val) {
        this.show1 = false;
        this.show2 = false;
        this.show3 = false;
      } else {
        this.goodstypeId = 0;
      }
    },
    show1(newVal, oldVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.listHeight1 = [];
          this.scrollY1 = 0; //实时获取当前y轴的高度
          this.clickEvent1 = false;
          this._getHeight1();
          this._initScroll1();
        });
      } else {
        this.stopScroll();
      }
    },
  },
  computed: {
    select() {
      return 1;
    },
  },
  methods: {
    Qdcity(item) {
      console.log("item: ", item);
      this.showFormCity = false;
      this.fromstoreName = item.namec;
      this.fromCityid = item.code;
      this.show1 = false;
      // this.show2 = true;
      // this.getFBAcount();
      sessionStorage.setItem("fromCityid", this.fromCityid);
    },
     stopScroll() {
      this.rights1 = new BScroll(this.$refs.right1, {
        probeType: 3, //探针的效果，实时获取滚动高度
        mouseWheel: true, // 开启鼠标滚轮模式
        disableMouse: true,
        // click: true,
      });
      this.rights1.on("scrollEnd", () => {
        console.log("scrollEnd");
      });
    },
     _initScroll1() {
      // console.log("_initScroll");
      this.lefts1 = new BScroll(this.$refs.left1, {
        click: true,
        mouseWheel: true,
        // tap: true,
      });
      this.rights1 = new BScroll(this.$refs.right1, {
        probeType: 3, //探针的效果，实时获取滚动高度
        mouseWheel: true, // 开启鼠标滚轮模式
        disableMouse: true,
        // click: true,
      });
      this.rights1.on("scroll", (pos) => {
        this.scrollY1 = Math.abs(Math.round(pos.y));
        for (let i = 0; i < this.listHeight1.length; i++) {
          let height = this.listHeight1[i];
          let height2 = this.listHeight1[i + 1];
          if (
            !height2 ||
            (this.scrollY1 >= height && this.scrollY1 < height2)
          ) {
            this.showTag1 = i;
            return i;
          }
          if (
            this.listHeight1[this.listHeight1.length - 1] -
              this.$refs.right1.clientHeight <=
            this.scrollY1
          ) {
            if (this.clickTrue) {
              return this.currentNum;
            } else {
              this.showTag1 = this.listHeight1.length - 1;
              return this.listHeight1.length - 1;
            }
          } else {
            this.showTag1 = 0;
          }
        }
      });
    },
    _getHeight1() {
      let rightItems =
        this.$refs.right1.getElementsByClassName("right-item-hook1");
      console.log("3333", rightItems);
      let height = 0;
      this.listHeight1.push(height);
      for (let i = 0; i < rightItems.length; i++) {
        let item = rightItems[i];
        height += item.clientHeight;
        this.listHeight1.push(height);
      }
      console.log("this.listHeight1", this.listHeight1);
    },
     selectItem1(index, event) {
      this.clickEvent1 = true;
      //在better-scroll的派发事件的event和普通浏览器的点击事件event有个属性区别_constructed
      //浏览器原生点击事件没有_constructed所以当时浏览器监听到该属性的时候return掉
      // debugger
      if (!event._constructed) {
        return;
      } else {
        let rightItems =this.$refs.right1.getElementsByClassName("right-item-hook1");
        let el = rightItems[index];
        this.rights1.scrollToElement(el, 300);
      }
    },
    getFBAstartplace() {
      this.axios
        .post("/ies/jiuyu/getAllCityByConuty")
        .then((res) => {
          console.log("起运地: ", res);
          this.startPlaceList = res.data.datas;
          this.fromCityid = this.startPlaceList[0].fromCityDTOList[0].cityCode; //默认城市id
          this.fromstoreName = this.startPlaceList[0].fromCityDTOList[0].cityNameCn;
          let arrList = [];
          let arr = [];
          this.startPlaceList.map((item) => {
            item.fromCityDTOList.map((_item) => {
              arr.push({
                namec: _item.cityNameCn,
                id: _item.id,
                code: _item.cityCode,
                namee: _item.cityNameEn,
              });
            });
            arrList.push({
              letters: item.code,
              content: [...arr],
            });
            arr = [];
          });
          console.log("arr", arr);
          this.startCitylist.push(...arrList);
          console.log("this.startCitylist: ", this.startCitylist);
        })
        .catch((res) => {});
    },


    handleClickTips() {},

    // getFBAfromCk() {
    //   // /ies/jiuyu/getAllCityByConuty
    //   this.axios
    //     .post("/ies/jiuyu/getAllCityByConuty")
    //     .then((res) => {
    //       console.log("provice", res);
    //       if (res.data.code == 200) {
    //         let all = res.data.datas;
    //         // this.startList = all.splice(1, all.length);
    //         // this.startFisrtList = this.startList;
    //         this.startList = all;
    //         this.startFisrtList = all;
    //         this.info = [all[0].cityNameCn, all[0].voList[0].cityNameCn];
    //         this.infoValue = all[0].voList[0].cityCode;
    //         this.firstvalue = all[0]
    //       } else {
    //         // data.message
    //         this.$message({
    //           type: "error",
    //           message: res.data.message,
    //         });
    //       }
    //     })
    //     .catch((res) => {
    //       console.log("fial", res);
    //     });
    // },
    getFBAtoCk() {
      //获取fba仓库
      this.axios
        .post("/ies/jiuyu/Countrylist")
        .then((res) => {
          console.log("end---", res);
          // this.FBAtoCk = res.data.datas;
          // this.editableTabs[0].list = res.data.datas;
          if (res.data.code == 200) {
            this.endList = res.data.datas;
          } else {
            // data.message
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((res) => {});
    },

    // 目的国选中
    handleEnd(item) {
      this.tocountryName = item.countryName;
      this.endValue = item;
      this.show2 = false;
    },

    // 查询
    handleSearch() {
      // console.log("===", this.info[1], this.endValue.countryName);

      // return
      // if (!this.transportQuery) {
      //   return this.$message({
      //     type: "error",
      //     message: "请先选择运输方式",
      //   });
      // }
      if (!this.endValue) {
        return this.$message({
          type: "error",
          message: "请先选择目的地",
        });
      }

      let data = {
        depCityCode: this.fromCityid, // 起运地，取城市代码
        desCountryCode: this.endValue.countryCode, // 目的地，取国家代码
        goodsType: "", // 货物类型， ALL:全部，PH：普货，MH：敏货
        lineType: this.transportQuery, // 线路类型
      };
      let startEnd = {
        start: this.fromstoreName,
        end: this.endValue.countryName,
        info: this.info,
      };
      this.axios
        .post("/ies/jiuyu/getQuoteList", data)
        .then((res) => {
          console.log("search---", res);
          // this.FBAtoCk = res.data.datas;
          // this.editableTabs[0].list = res.data.datas;
          if (res.data.code == 200) {
            // if (res.data.datas.length == 0) {
            //   this.$message({
            //     type: "error",
            //     message: "暂无此线路报价,请联系业务员",
            //   });
            // } else {
              // debugger
              this.$router.push({
                name: "Smallbag",
                query: {
                  objData: JSON.stringify(data),
                  info: JSON.stringify(startEnd),
                },
              });
            // }
          } else {
            // data.message
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((res) => {});

      console.log(
        "handleSearch",
        this.firstvalue,
        this.secondValue,
        this.endValue,
        this.transportQuery,
        this.infoValue
      );
    },
    // 获取查询路线
    getAllLine() {
      this.axios
        .post("/ies/jiuyu/lineType")
        .then((res) => {
          console.log("line---", res);
          // this.FBAtoCk = res.data.datas;
          // this.editableTabs[0].list = res.data.datas;
          if (res.data.code == 200) {
            this.allLine = [{ code: "", nameCn: "全部" }, ...res.data.datas];
          } else {
            // data.message
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((res) => {});
    },
  },

  created() {},
  mounted() {
    document.addEventListener("click", (e) => {
      let thisClassName = e.target.className;
      if (thisClassName !== "transition-box") {
        this.show1 = false;
        this.show2 = false;
        this.show3 = false;
        this.isShow = false;
      }
    });
    // 获取全部
    this.getAllLine();
    // 起运地数据
    // this.getFBAfromCk();
    // 目的地数据
    this.getFBAtoCk();
    // 
    this.getFBAstartplace();
  },
};
</script>

<style lang="scss" scoped>
.Hotcounter {
  width: 20%;
  box-sizing: border-box;
  float: left;
  padding: 0 10px;
  height: 110px;
  margin-bottom: 18px;
  position: relative;
  // overflow: hidden;
}
.Hotcounter >>> .el-card__body {
  padding: 20px;
}

.txt1 {
  color: #000;
}

.txt2 {
  color: #FF4D01;
}

.Processlist {
  float: left;
  box-sizing: border-box;
  width: 100%;
  background: #fff8f9;
  position: relative;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
.Hovericon {
  display: none;
  position: absolute;
  bottom: 8px;
  right: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ffffff;
  text-align: center;
  line-height: 30px;
  color: black;
}

.headerTop {
  /* 初始样式 */
  transition: 0.3s;
  margin-top: 0%;
}
.showTop {
  width: 100%;
  transition: 0.3s;
  margin-top: 356px;
}
.Hotwrap {
  width: 100%;
  float: left;
  margin: 0 auto;
  margin-top: 126px;
}
.hottitel {
  position: absolute;
  display: flex;
  align-items: center;
  color: #333333;
}

.hotlist {
  width: 100%;
  float: left;
}
.hotItem {
  width: 100%;
  height: 176px;
  background: #ffffff;
  box-sizing: border-box;
  float: left;
}
.hindDown {
  display: none;
}
.showDown {
  transition: 0.3s;
  transform: translate(0, -76px);
}
.wrap_s {
  float: left;
}
.Thicon {
  background: url("../../assets/thiconi.png") no-repeat;
  background-size: 100% 100%;
  width: 15px;
  height: 15px;
  text-align: center;
  color: #c6c6c6;
  font-weight: bold;
  float: left;
  margin-right: 5px;
  margin-top: 2px;
}

.Zxicon {
  background: url("../../assets/zx.png") no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 2px;
  margin-top: 3px;
}

.Xqicon {
  background: url("../../assets/zx.png") no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 2px;
  margin-top: 3px;
}

.Qxdicon {
  background: url("../../assets/qxd.png") no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  float: left;
  margin-right: 2px;
  margin-top: 3px;
}
.navItem {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: block;
  float: left;
  margin-right: 52px;
  margin-left: 20px;
  position: relative;
  cursor: pointer;
}
.navson {
  width: 6px;
  height: 6px;
  background: #ffffff;
  border-radius: 50%;
  position: absolute;
  left: -19px;
}
.activesonty {
  color: #FF4D01;
}
.activesonty2 {
  border: 2px solid #FF4D01;
}
.Gotobtn {
  cursor: pointer;
  // margin-top: -10px;
  width: 170px;
  height: 50px;
  background: #FF4D01;
  border-radius: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: PingFang SC;
  color: #ffffff;
}
.checkbox {
  margin-top: 8px;
  width: 170px;
  height: 30px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}

.card_wrap {
  min-width: 1100px;
  width: 1100px;
  background: #ffffff;
  box-shadow: 0px 0px 39px 5px rgba(208, 208, 208, 0.32);
  border-radius: 10px;
  float: left;
  padding: 24px 35px 34px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.Bom_style {
  width: 95px;
  height: 30px;
  background: #f9c158;
  border-radius: 15px;
  float: left;
  margin-right: 30px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
  border: 1px solid #fff !important;
}
.count_Bom {
  width: 100%;
  float: left;
  margin-top: 16px;
  min-height: 30px;
}
.showbgColor {
  background: #ffffff;
}
.show_count {
  transform: translate(0, 0);
  margin: 0 auto;
  box-sizing: border-box;
  // position: relative;
}
.huowuData {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-direction: column;
  padding: 0px 0 100px 0;
}
.select {
  position: relative;
}

.el-col {
  border-radius: 4px;
}

.selectWrap1 {
  background: rgb(245, 245, 245);
}

.count_text {
  margin-top: 20px;
  padding: 33px 26px 32px 22px;
  box-sizing: border-box;
  width: 80%;
  max-width: 1377px;
  background: #ffffff;
  border-radius: 100px !important;
  box-shadow: 0px 0px 62px 0px rgba(35, 35, 35, 0.11);
  float: left;
  z-index: 999;
}

.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.index_wrap {
  // background: url("../../assets/indexbg2.png") no-repeat;
  background-size: auto 100%;
  background-position: center;
  height: 728px;
  position: absolute;
}
.notBg {
  background: #ffffff;
  background-size: cover;
}
.drawer >>> .el-drawer__body {
  overflow: auto !important;
}
.transition-box {
  background: #ffffff;
  border-radius: 4px;
  text-align: left;
  padding: 40px 20px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  background-color: #fff;
  box-shadow: 0px 6px 21px 0px rgba(181, 181, 181, 0.5);
}
.divider >>> .el-divider--vertical {
  height: 2em;
}
.selectWrap {
  position: relative;
}
.selectWrap >>> .el-input__inner {
  text-align: left;
}

.selectWrap1,
.selectWrap2,
.selectWrap3,
.selectWrap4,
.selectWrap5 {
  position: relative;
}
.selectWrap1 >>> .el-input__inner {
  text-align: left;
}

.selectWrap2 >>> .el-input__inner {
  text-align: left;
}
.selectWrap3 >>> .el-input__inner {
  text-align: left;
}
.selectWrap4 >>> .el-input__inner {
  text-align: left;
}

.selectWrap5 >>> .el-input__inner {
  text-align: left;
}
.transition_son {
  position: absolute;
  bottom: -142px;
  left: 0;

  // box-shadow: 0px 2px 12px 0px rgba(0 0 0 / 10%);
  height: 136px;
}
.cityBtn {
  padding: 9px 9px;
  color: #666;
  cursor: pointer;
  float: left;
}
.cityBtn:hover {
  color: #FF4D01;
}
.el-message-box__btns {
  display: flex;
  flex-direction: row-reverse;
}

.step-info {
  min-width: 1100px;
  width: 1100px;
}

.count_text >>> .el-input__inner {
  border-radius: 100px !important;
}

.packet >>> .el-input__inner {
  border-radius: 100px !important;
}
.packet >>> i.el-select__caret.el-input__icon.el-icon-arrow-up {
  margin-right: 10px;
}

.packet >>> .transition-box {
  border-radius: 20px !important;
}
</style>

<style scoped>
.one-1 {
  display: flex;
  border-bottom: 1px solid #eee;
}

.test-1 {
  width: 20px;
  text-align: center;
  padding-bottom: 12px;
  cursor: pointer;
}

li.shops-li {
  display: flex;
}

.two-left {
  width: 60px;
  margin-right: 10px;
}

.two-right {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  width: 380px;
}

.twoShow {
  background: #FF4D01;
  color: white;
  cursor: pointer;
}

ul.left-all {
  display: flex;
  /* width: 20px; */
}

.right {
  width: 100%;
  height: 200px;
  overflow: auto;
  margin-top: 20px;
}
.left-tips {
  width: 20px;
  text-align: center;
  padding-bottom: 12px;
  cursor: pointer;
}
.current {
  font-size: 16px;
  border-bottom: 2px solid #FF4D01;
  color: #FF4D01;
}
.right::-webkit-scrollbar {
  display: none;
}
/* .shops-li.right-item-hook {
    margin-top: 10px;
    padding-top: 5px;
} */
.left-address {
  margin-top: -1px;
  margin-left: 5px;
  cursor: pointer;
  width: 60px;
  padding-bottom: 20px;
}

.show-tips {
  background: white;
  box-shadow: black;
  box-shadow: 0 6px 21px 0 hsl(0deg 0% 71% / 50%);
  padding: 20px;
}
.selectWrap5 >>> .el-tabs__item {
  padding: 0 4px;
}
.selectWrap3 >>> .el-tabs__item {
  padding: 0 4px;
}

.SlowAlterBac {
  transform: translateZ(0);
  position: relative;
  transition-property: color;
  transition-duration: 0.3s;
}
.SlowAlterBac:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #FF4D01;
  transform-origin: 110px 0;
  transform: scaleX(0);
  transition: transform 0.3s ease-out;
  /* border-radius: 60px 0 0 60px; */
}
.SlowAlterBac:hover,
.SlowAlterBac:focus,
.SlowAlterBac:active {
  color: white;
}
.SlowAlterBac:hover:before,
.SlowAlterBac:focus:before,
.SlowAlterBac:active:before {
  transform: scaleX(1);
}

.stepEnter2 {
  padding: 10px 20px;
}

.empty-box {
  padding: 70px 20px;
  position: relative;
}

.emptyClass {
  display: flex;
  justify-content: center;
  /* align-items: center; */
}

.empty-text {
  position: absolute;
  bottom: 20px;
}

.self_support {
  width: 50px;
  height: 26px;
  background-color: #FF4D01;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  color: #fff;
  margin-left: 10px;
}
.transportWrap >>> .el-input__inner {
  text-align: right !important;
}
.el-divider--vertical {
  margin: 0 16px;
}
.searchBtn {
  cursor: pointer;
  display: inline-block;
  min-width: 90px;
  height: 30px;
  background: #f5f5f5;
  border-radius: 15px;
  line-height: 30px;
  text-align: center;
  margin: 5px;
  overflow: hidden;
}
.searchBtn:hover {
  background: #FF4D01;
  color: #ffffff;
}
</style>

<style scoped>
.one-1 {
  display: flex;
  border-bottom: 1px solid #eee;
}

li.shops-li {
  display: flex;
}

.two-left {
  width: 50px;
  /* margin-right: 10px; */
  font-weight: bold;
}

.two-right {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  width: 460px;
}

/* .two-all {
  padding: 0 6px;
  background: #f5f5f5;
  margin-right: 10px;
  margin-bottom: 6px;
  border-radius: 20px;
  color: #666;
  cursor: pointer;
  min-width: 60px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} */
.two-all {
  width: 60px;
  padding: 6px 10px;
  background: #f5f5f5;
  margin-right: 10px;
  margin-bottom: 6px;
  border-radius: 20px;
  color: #666;
  cursor: pointer;
  min-width: 60px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.two-all:hover {
  background: #FF4D01;
  color: white;
  cursor: pointer;
}
.twoShow {
  background: #FF4D01;
  color: white;
  cursor: pointer;
}
ul.left-all {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.right {
  width: 100%;
  height: 200px;
  overflow: auto;
  padding-top: 20px;
}
.left-tips {
  padding: 0 3px;
  text-align: center;
  padding-bottom: 15px;
  cursor: pointer;
}

.right::-webkit-scrollbar {
  display: none;
}
/* .shops-li.right-item-hook {
    margin-top: 10px;
    padding-top: 5px;
} */
.left-address {
  margin-top: -1px;
  margin-left: 5px;
  cursor: pointer;
  width: 60px;
  padding-bottom: 20px;
}

.selectWrap3 >>> .el-tabs__item {
  padding: 0 4px;
}

.SlowAlterBac {
  transform: translateZ(0);
  position: relative;
  transition-property: color;
  transition-duration: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.SlowAlterBac:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #FF4D01;
  transform-origin: 110px 0;
  transform: scaleX(0);
  transition: transform 0.3s ease-out;
  /* border-radius: 60px 0 0 60px; */
}
.SlowAlterBac:hover,
.SlowAlterBac:focus,
.SlowAlterBac:active {
  color: white;
  border: 1px solid #ccc;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.2);
}
.SlowAlterBac:hover:before,
.SlowAlterBac:focus:before,
.SlowAlterBac:active:before {
  transform: scaleX(1);
}
.empty-box {
  padding: 70px 20px;
  position: relative;
}

.emptyClass {
  display: flex;
  justify-content: center;
  /* align-items: center; */
}

.empty-text {
  position: absolute;
  bottom: 20px;
}

.self_support {
  width: 50px;
  height: 26px;
  background-color: #FF4D01;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  color: #fff;
  margin-left: 10px;
}

.current {
  font-size: 16px;
  border-bottom: 2px solid #FF4D01;
  color: #FF4D01;
}
.left-all .left-tips:first-child{
  width: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/packet.vue